export default __webpack_public_path__ + "static/media/wfp.c4c408d7.svg";